<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showMerchantApprovedRejectProductSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="cp-header-title">Reject Product</div>
        </div>
    </ng-template>

    <merchant-reject-product [_displayModalReject]="showMerchantRejectProductModal"
                             [merchantApprovedRejectProductComponent]="this"
                             (changedDisplayModalMerchantRejectProductEmit)="changedShowMerchantRejectProductModalEmit($event)"></merchant-reject-product>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 200px)'}"
                       [styleClass]="'app-scrollpanel'">

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="cp-upload-img-block">
                            <img class="cp-upload-img-block__img" src="{{product.ImageUrl}}" />
                        </div>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-product-name">{{product.Name}}</div>
                    </div>
                    <div class="merchant-form">
                        <div class="merchant-product-description">{{product.Description}}</div>
                    </div>
                </div>
            </div>

            <div>
                <hr />

                <div class="verification-questions-body">
                    <div class="verification-questions-title">
                        Review
                    </div>
                    <div class="verification-questions" *ngFor="let item of questions">
                        <div class="question-column-70">
                            <div class="verification-name">{{item.name}}</div>
                        </div>
                        <div class="question-column-30">
                            <div class="verification-question-switch">
                                <p-inputSwitch [(ngModel)]="item.isChecked" (click)="addOrUpdateMerchantVerificationCheckList(item)"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                    <div class="merchant-form">
                        <div class="merchant-label-reasons">Other reasons</div>
                        <textarea class="textarea-reject" rows="5" cols="30" [(ngModel)]="product.RejectReason" placeholder="Type here..." pInputTextarea></textarea>
                    </div>
                </div>
            </div>

        </p-scrollPanel>
        <div class="flex justify-content-end mrg-10-0px">
            <button class="red-btn" pButton label="Reject" style="margin-right: 10px;" (click)="openMerchantRejectProductModal()"></button>
            <button class="green-btn" pButton label="Approve" (click)="approvedOrReject(productStatusEnum.Approved)"></button>
        </div>
    </div>

</p-sidebar>